import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { EditCreativeText } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const EditCreativeTextPage: FC = () => {
  const { accessToChangeOriginaltextcreative } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToChangeOriginaltextcreative}>
      <CabinetTitlePage
        title={'Creative texts'}
        goBack={'/cabinet/facebook/creative-texts'}
      />
      <EditCreativeText />
    </Guard>
  );
};

export default EditCreativeTextPage;
